<h5>Operações garantidas</h5>

<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="col">
      <h3>Filtros de pesquisa</h3>
    </div>
    <div class="mb-3 botoes">
      <div class="float-end btn1">
        <span class="d-inline-block" tabindex="0" ngbTooltip="Tela para contratação de operação individual.">
          <button class="btn btn-primary botaoMenor " type="button" [routerLink]="['/operacoes/cadastro']"
            [disabled]="!podeCriarOperacao"><i class="fa fa-file-signature">
            </i> Envio Individual</button>
        </span>
      </div>
      <div class="float-end btn2">
        <span class="d-inline-block" tabindex="0" ngbTooltip=" Enviar lote de operações/liberações/amortizações.">
          <button class="btn btn-primary botaoMenor " type="button" [routerLink]="['/operacoes/cadastro/lote']"
            [disabled]="!podeCriarOperacao"><i class="fa fa-upload">
            </i> Envio em Lote</button>
        </span>
      </div>
      <div class="float-end btn3">
        <button type="button" class="btn btn-light botaoMenor" (click)="limpar()">Limpar</button>
        <div style="cursor: pointer;" id="pesquisa_avancada" (click)="togglePesquisaAvancada()"
          class="float-bottom letra-miuda">
          <div>Pesquisa
            Avançada <i class="fas fa-angle-double-up clica" style="cursor: pointer;" aria-hidden="true"
              *ngIf="pesquisaAvancada">
            </i>
            <i class="fas fa-angle-double-down" style="cursor: pointer;" aria-hidden="true" *ngIf="!pesquisaAvancada">
            </i>
          </div>
        </div>
      </div>
      <div class="float-end btn4">
        <button #focusableSubmit type="button" [disabled]="!agentesFinanceiros?.length" 
          class="btn btn-success botaoMenor" (keydown.enter)="buscar(false, true, true)"
          (click)="buscar(false, true, true)">Pesquisar</button>
      </div>
    </div>


    <div class="row" style="padding-top: 10px;">

      <div class="mb-3 col-md-3">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select *ngIf="podeEscolherAgente" id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId"
          formControlName="agenteFinanceiro" (change)="atribuiAgenteFinanceiroSelecionado($event.target.value)">
          <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.agenteFinanceiro">Todos
          </option>
          <option *ngFor="let agente of agentesFinanceiros"
            [selected]="valoresPesquisaForm && valoresPesquisaForm.agenteFinanceiro == agente.nome">{{ agente.nome }}
          </option>
        </select>

        <select *ngIf="!podeEscolherAgente" disabled id="agenteFinanceiro" class="form-select"
          [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <ng-container *ngFor="let agente of agentesFinanceiros">
            <option selected *ngIf="agente?.cnpj == cnpjUsuario">{{ agente.nome }}</option>
          </ng-container>
        </select>
      </div>

      <div class="mb-3 col-md-3"> 
        <label class="form-label" for="idOperacao"> Id. ope. cred.: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador da operação gerado automaticamente pelo FGI."></i>
        </label>
        <input class="form-control" type="text" formControlName="idOperacao" appNumbersOnly>
      </div>

      <div class="mb-3 col-md-3">
        <label class="form-label">Id. ope. ag.: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Identificador do protocolo da operação informado pelo Agente Financeiro
          (em operações Crédito Livre) ou o identificador de protocolo do BNDES Online (em operações de Repasse BNDES)."></i>

        </label>
        <input class="form-control" formControlName="idExternoOperacao" appNoSpaces>
      </div>

      <div class="mb-3 col-md-3">
        <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
            ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>

        </label>
        <input class="form-control" formControlName="contrato" appNoSpaces>
      </div>
    </div>

    <div [class.collapse]="!pesquisaAvancada">
      <div class="row">

        <div class="mb-3 col-md-3">
          <label class="form-label" for="tipoOperacao">Tipo de operação: </label>
          <select id="tipoOperacao" class="form-select" formControlName="tipoOperacao">
            <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.tipoOperacao">Todos
            </option>
            <option *ngFor="let tipoOperacao of tiposOperacao"
              [selected]="valoresPesquisaForm && valoresPesquisaForm.tipoOperacao == tipoOperacao.codigo"
              [ngValue]="tipoOperacao.codigo">{{ tipoOperacao.label }}</option>
          </select>
        </div>

        <div class="mb-3 col-md-3">
          <label class="form-label" for="tranche">Cesta: </label>
          <select id="tranche" class="form-select" formControlName="ideTranche">
            <option [ngValue]=null></option>
            <option [ngValue]="tranche.id" *ngFor="let tranche of tranches">
              {{tranche.numeroTranche}} ({{tranche.dataInicioContratacao | date: 'dd/MM/yyyy'}})</option>
          </select>
        </div>

        <div class="mb-3 col-md-3">
          <label class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
          </label>
          <select id="sistema" class="form-select" [compareWith]="compararPorId" formControlName="sistema">
            <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.sistema">Todos
            </option>
            <option [ngValue]="15" [selected]="valoresPesquisaForm && valoresPesquisaForm.sistema == 15">15</option>
            <option [ngValue]="89" [selected]="valoresPesquisaForm && valoresPesquisaForm.sistema == 89">89</option>
          </select>
        </div>


        <div class="mb-3 col-md-3">
          <label class="form-label" for="estado">Estado:</label>
          <select id="estado" class="form-select" [compareWith]="compararPorId" formControlName="estado">
            <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.estado">Todos
            </option>
            <option *ngFor="let estado of estados"
              [selected]="valoresPesquisaForm && valoresPesquisaForm.estado == estado.nome">{{ estado.nome }}</option>
          </select>
        </div>

      </div>

      <div class="row">
        <div class="mb-3 col-md-3">
          <label class="form-label" for="dataContratacaoInicial">Data de contratação inicial:</label>
          <bn-datepicker name="dataContratacaoInicial" idInput="dataContratacaoInicial"
            formControlName="dataContratacaoInicial">
          </bn-datepicker>
        </div>

        <div class="mb-3 col-md-3">
          <label class="form-label" for="dataContratacaoFinal">Data de contratação final:</label>
          <bn-datepicker name="dataContratacaoFinal" idInput="dataContratacaoFinal"
            formControlName="dataContratacaoFinal">
          </bn-datepicker>
        </div>

        <div class="mb-3 col-md-3">
          <label class="form-label" for="dataEnvioInicial">Data de envio inicial:</label>
          <bn-datepicker name="dataEnvioInicial" idInput="dataEnvioInicial" formControlName="dataEnvioInicial">
          </bn-datepicker>
        </div>

        <div class="mb-3 col-md-3">
          <label class="form-label" for="dataEnvioFinal">Data de envio final:</label>
          <bn-datepicker name="dataEnvioFinal" idInput="dataEnvioFinal" formControlName="dataEnvioFinal">
          </bn-datepicker>
        </div>
      </div>
      <div class="row" *ngIf="podeEscolherAgente">

        <div class="mb-3 col-md-6">
          <label class="form-label" for="idModalidadeOperacao">Modalidade:</label>
          <select id="idModalidadeOperacao" class="form-select" formControlName="idModalidadeOperacao">
            <option [ngValue]="undefined" [selected]="!valoresPesquisaForm || !valoresPesquisaForm.idModalidadeOperacao">Todos
            </option>
            <option *ngFor="let item of dadosDominio.modalidades"
              [selected]="valoresPesquisaForm && valoresPesquisaForm.idModalidadeOperacao == item.id"
              [ngValue]="item.id">{{ item.nome }}</option>
          </select>   
        </div>

        <div class="mb-3 col-md-3">
          <label class="form-label">CPF/CNPJ beneficiário: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="O número do CPF/CNPJ do beneficiário (apenas números - sem pontos/traços). No caso do CNPJ, a consulta é realizada pela raiz do documento."></i>
  
          </label>
          <input class="form-control" formControlName="cpfOuCnpjBeneficiario" appNumbersOnly>
        </div>
        <div class="mb-3 col-md-3">
          <label class="form-label" for="idLimiteAdicional">Limite Adicional:</label>
          <select id="idLimiteAdicional" class="form-select" formControlName="idLimiteAdicional">
            <option [ngValue]="undefined"></option>
            <option [ngValue]="l.id" *ngFor="let l of limitesAdicionais">{{ l.nome }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>

<bn-loading-overlay></bn-loading-overlay>
<!-- exemplo de passagem de dados para outro componente -->
<app-operacao-listagem *ngIf="pesquisado" [operacoes]="operacoes"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem" [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  (aoMudarPagina)="mudancaPagina($event)" (exportarAditivos)="exportarAditivos()"
  (exportarOperacoes)="exportarOperacoes()" (exportarLiberacoes)="exportarLiberacoes()"
  (exportarAmortizacoes)="exportarAmortizacoes()" [agentesFinanceiros]="agentesFinanceiros"
  (mudarOrdenacao)="aplicarOrdenacaoEBuscar($event)">

</app-operacao-listagem>